import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'negativeparentheses'
})
export class NegativeParenthesesPipe implements PipeTransform {

    transform(value: string, args?: any): string {
        if (value && value.charAt(0) === '-') {
            return '(' + value.substring(1) + ')';
        } else {
            return value;
        }
    }
}
